import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { deviceMax } from "../../../utils/variables";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  // BlueSkyShareButton,
  // InstagramShareButton,
} from "react-share";
import {
  formatShortDate,
  idToText,
  isValidEmail,
  logAnalyticEvent,
  getUrlParams,
} from "../../../utils";
import { getUserByEmail } from "../../../store/queries/user";
import { CircleFlag } from "react-circle-flags";
import moment from "moment";

import {
  Header,
  Drawer,
  Circle,
  H4,
  Row,
  Icon,
  Label,
  Toast,
  Column,
  RowToColumn,
  Button,
  P,
  Modal,
  Checkbox,
  Input,
  Grid,
  ListItem,
  Avatar,
  HR,
  H1,
  H2,
  Anchor,
} from "../../../components";
import { Color, currentYear } from "../../../utils/variables";
import { Spinner } from "../../../components/Spinner";
import { formatNumber, formatShortDates } from "../../../utils";
import { DonutChart } from "./DonutChart";
import { SmothLineChart } from "../../../components/SmothLineChart";
import { TextLogo } from "../../../components/Header";

export const HeaderAndDrawer = ({ signUpClick, activeUrl, isAdmin }) => {
  const location = useLocation();
  const path = location.pathname;
  const [menu, setMenu] = useState([
    {
      id: "influencers/hashtag",
      label: "Conference hashtags",
      dropdown: true,
      visible: true,
    },
    {
      id: "influencers/disease",
      label: "Disease influencers",
      dropdown: true,
      visible: true,
    },
    {
      id: "influencers/conference",
      label: "Conference influencers",
      dropdown: true,
      visible: isAdmin,
    },
    // {
    //   id: "disease_insights",
    //   label: "Disease insights",
    //   dropdown: true,
    // },
  ]);

  useEffect(() => {
    const newMenu = menu.map((item) => ({
      ...item,
      active: activeUrl === item.id || path.includes(item.id),
      to: path.includes(item.id) ? undefined : `/${item.id}`,
    }));
    setMenu(newMenu);
  }, [path]);

  const handleMenuItemChange = (item) => {
    if (item.to) {
      window.location.href = item.to;
    }
  };

  return (
    <>
      <Header
        isHome
        login
        user
        menu={menu.filter((item) => item.visible)}
        {...{ signUpClick }}
      />
      <Drawer
        login
        headerMenu
        items={menu.filter((item) => item.visible)}
        active={menu.find((item) => item.active)?.id}
        itemOnChange={handleMenuItemChange}
        signUpClick={signUpClick}
      />
    </>
  );
};

export const OncoalertHeader = ({ handleSignUpClick }) => {
  const auth = useSelector((state) => state.auth.data);

  return (
    <Header
      logo
      user={auth?.active}
      oncoAlert
      rightContent={
        !auth?.active && (
          <>
            <Row show="tablet">
              <Button
                secondary
                color="blue"
                label="Sign up for newsletter"
                onClick={() => handleSignUpClick?.()}
              />
            </Row>
            <Row hide="tablet">
              <Button
                secondary
                color="blue"
                label="Sign up"
                onClick={() => handleSignUpClick?.()}
              />
            </Row>
          </>
        )
      }
    />
  );
};

export const Counter = ({ number }) => {
  return (
    <Circle radius="17" bkg="gray" fade="1" className="counter">
      <H4 bold>{number}</H4>
    </Circle>
  );
};

const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    props.noBorder ? "none" : `1px solid ${Color("gray", "4")}`};
  background-color: white;
  color: black;
  border-radius: 4px;
  transition: all 0.3s ease;
  width: 44px;
  height: 44px;
  cursor: pointer;

  &:hover {
    background-color: ${Color("gray", "1")} !important;
  }

  &:focus {
    outline: none;
    border: 1px solid ${Color("gray", "4")};
  }

  svg {
    fill: black !important;
    width: 20px !important;
    height: 20px !important;
  }
`;

const AnchorWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Color("gray", "4")};
  background-color: white;
  color: black;
  border-radius: 4px;
  transition: all 0.3s ease;
  width: 44px;
  height: 44px;
  cursor: pointer;

  &:hover {
    background-color: ${Color("gray", "1")} !important;
  }

  svg {
    fill: black !important;
    width: 20px !important;
    height: 20px !important;
  }
`;

const ShareButton = ({ icon, onClick, noBorder }) => {
  return (
    <ButtonWrapper onClick={() => onClick?.() || {}} {...{ noBorder }}>
      <Icon name={icon} />
    </ButtonWrapper>
  );
};

const ShareAnchor = ({ icon, blank, to }) => {
  return (
    <AnchorWrapper href={to} target={blank ? "_blank" : undefined}>
      <Icon name={icon} />
    </AnchorWrapper>
  );
};

export const Share = ({ title, oncoalert }) => {
  const [showToast, setShowToast] = useState(false);

  const handleCopyToClipboard = () => {
    setShowToast(true);
  };

  return (
    <>
      {oncoalert ? (
        <Row gap="10" middle>
          <Label bold>Share on</Label>

          <TwitterShareButton url={window.location.href} title={title}>
            <ShareButton icon="twitter" />
          </TwitterShareButton>
          {/* <BlueSkyShareButton url={window.location.href} title={title}>
            <ShareButton icon="twitter" />
          </BlueSkyShareButton> */}
          {/* <InstagramShareButton url={window.location.href} title={title}>
            <ShareButton icon="instagram" />
          </InstagramShareButton> */}
        </Row>
      ) : (
        <Row gap={oncoalert ? "0" : "10"} middle>
          <Label bold>Share</Label>

          <CopyToClipboard
            text={window.location.href}
            onCopy={() => handleCopyToClipboard()}
          >
            <ShareButton icon="link" />
          </CopyToClipboard>
          <ShareAnchor
            to={`mailto:?subject=${title}&body=${window.location.href}`}
            blank
            icon="email"
          />
          <FacebookShareButton url={window.location.href} title={title}>
            <ShareButton icon="facebook" />
          </FacebookShareButton>
          <TwitterShareButton url={window.location.href} title={title}>
            <ShareButton icon="twitter" />
          </TwitterShareButton>
          <LinkedinShareButton url={window.location.href} title={title}>
            <ShareButton icon="linkedin" />
          </LinkedinShareButton>
        </Row>
      )}
      <Toast
        visible={showToast}
        toggleVisibility={setShowToast}
        expiration={2000}
      >
        <Row gap="5" middle>
          <Icon name="check" />
          <Label>URL copied to your clipboard!</Label>
        </Row>
      </Toast>
    </>
  );
};

const ImageWrapper = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "244px")};
  height: ${({ height }) => (height ? `${height}px` : "122px")};
`;

const Image = styled.img`
  width: ${({ width }) => (width ? `${width}px` : "244px")};
  height: ${({ height }) => (height ? `${height}px` : "122px")};
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid ${Color("gray", "4")};
`;

const FallbackImage = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "244px")};
  height: ${({ height }) => (height ? `${height}px` : "122px")};
  background-color: ${Color("gray", "1")};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InsightsCard = ({ data }) => {
  return (
    <Link
      // to={`/insight/${data.objectId}/${data.id}`}
      to={`/insight/${idToText(data.name)}/${
        data.createdAt.split("T")[0]
      }/${idToText(data.title)}/?id=${data.id}&objectId=${data.objectId}`}
    >
      <Column gap="10">
        <RowToColumn gap="20" columnGap="10" device="mobileXL">
          <ImageWithError data={data.post} />
          <Column gap="5">
            <Label large>{data.title}</Label>
            <Label color="gray" fade="7">
              By {data.post.tAccount.name}
            </Label>
            <Label color="gray" fade="7">
              {formatShortDate(data.post.createdAt)}
            </Label>
          </Column>
        </RowToColumn>
      </Column>
    </Link>
  );
};

export const ImageWithError = ({ data, width, height }) => {
  const [imageError, setImageError] = React.useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <ImageWrapper {...{ width, height }}>
      {data.tAccount.imageURL && !imageError ? (
        <Image
          {...{ width, height }}
          src={data.tAccount.imageURL?.replace("_bigger", "")}
          onError={handleImageError}
          alt={`${data.tAccount.name}'s profile`}
        />
      ) : (
        <FallbackImage {...{ width, height }}>
          <Icon name="noImage" />
        </FallbackImage>
      )}
    </ImageWrapper>
  );
};

export const OncoalertModal = ({
  visible,
  toggleVisibility,
  events,
  handlePreviousPage,
}) => {
  const queryParams = getUrlParams(location.search);
  const auth = useSelector((state) => state.auth.data);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [agree, setAgree] = useState(true);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const submit = (e) => {
    e.preventDefault();
    if (isValidEmail(email)) {
      logAnalyticEvent(
        "Subscribe",
        {
          page: events?.page,
          ...(events?.name && { name: events.name }),
          email,
        },
        auth?.id || queryParams?.u || null,
        auth?.displayName || queryParams?.n || null,
        auth?.email || queryParams?.e || null,
        auth?.createdAt || null,
        auth?.preferences?.filter((p) => p.preferenceName === "UserType")?.[0]
          ?.preferenceStringValue ||
          queryParams?.t ||
          "MEDICAL",
        null
      );
      getUserByEmail(email).then((userResp) => {
        if (userResp.data?.id) {
          setError(
            "This email already exists. Please use the 'Sign in' link below"
          );
        } else {
          // user not found, so we can proceed with signup
          handlePreviousPage();
          const url =
            "/signup?email=" + encodeURIComponent(email) + "&oncoalert=true";
          window.location.href = url;
        }
      });
    } else {
      setError("Invalid email");
    }
  };

  return (
    <Modal
      color="blue"
      visible={visible}
      toggleVisibility={toggleVisibility}
      close
      maxWidth="560"
      noPadding
      // leftAligned
      title="Want practice changing updates in oncology/hematology?"
    >
      <form onSubmit={(e) => submit(e)}>
        <Column gap="40">
          <Label large color="gray" fade="7">
            Get our weekly newsletter. 🙂
          </Label>

          <Checkbox
            color="blue"
            checked={agree}
            label="I agree to receiving scientific, non-promotional materials from OncoAlert and Medical.watch"
            onChange={() => setAgree(!agree)}
            errorMessage={!agree && "Agree to our terms to subscribe"}
          />

          <Column gap="20">
            <Input
              expand
              placeholder="Enter email"
              value={email}
              onChange={handleEmailChange}
              errorMessage={error}
              errorTop
              disabled={!agree}
            />
            <Row marginTop="3" middle gap="20" expand>
              <Button
                large
                color="blue"
                label="Subscribe for free"
                disabled={!agree}
              />
              {/* <Row gap="10">
                <Label large color="gray" fade="7">
                  Existing user?
                </Label>
                <Anchor large bold to="/login" label="Sign in" />
              </Row> */}
            </Row>
          </Column>
        </Column>
      </form>
    </Modal>
  );
};

const InfluencerListWrapper = styled(Column)`
  @media ${deviceMax.mobileL} {
    .list-item {
      border-radius: 0;
      margin-bottom: -10px;
      padding: 10px;
      border-top: 1px solid ${Color("gray", "2")};
    }
  }
`;

export const InfluencerList = ({
  influencers,
  isLoading,
  isSuccess,
  title,
  subtitle,
  counter,
  image,
  setMaxResult,
  maxResult,
  oncoalert,
}) => {
  const maxMentions = influencers?.[0]?.mentions;
  return (
    <InfluencerListWrapper bkg="white">
      {image ? (
        <Column paddingAll gap="2" maxWidth="290">
          <Label large bold>
            {title}
          </Label>
          <Label small color="gray" fade="7">
            {subtitle}
          </Label>
        </Column>
      ) : (
        <Column gap="2" maxWidth="580">
          <H4 bold>{title}</H4>
          <Label color="gray" fade="7">
            {subtitle}
          </Label>
        </Column>
      )}

      {isLoading && (
        <Row marginY="40" expand center>
          <Spinner color={oncoalert ? "blue" : null} />
        </Row>
      )}

      {isSuccess && influencers?.length === 0 && (
        <Row marginY="40" expand center>
          <Label color="gray" fade="7">
            No influencers found!
          </Label>
        </Row>
      )}

      {influencers?.length > 0 && (
        <Column
          gap="10"
          marginTop={image ? "5" : "20"}
          paddingX={image ? "20" : "0"}
        >
          {influencers?.map((dol, index) => {
            dol = dol.account ? dol.account : dol;
            return (
              <Column marginX="-10" key={dol.id}>
                <a
                  href={
                    oncoalert
                      ? `https://www.x.com/${dol.username}`
                      : `/account/${dol.id}`
                  }
                  target={oncoalert ? "_blank" : "_self"}
                >
                  <ListItem
                    className="list-item"
                    expand
                    middle
                    hover
                    radius="20"
                  >
                    <Row gap="10" middle expand>
                      <RowToColumn device="mobileL" fit gap="10" truncate>
                        <Row middle gap="10">
                          {!image && <Counter number={index + 1} />}
                          <Avatar
                            imageUrl={dol.imageURL}
                            name={dol.name}
                            large={!image}
                          />
                        </Row>
                        {image ? (
                          <Column truncate>
                            <Label bold truncate>
                              {index + 1} {dol.name}
                            </Label>
                            <Row gap="5">
                              <Label small color="gray" fade="7">
                                @{dol.username}
                              </Label>
                              {counter === "impressions" && (
                                <Label
                                  small
                                  color="gray"
                                  fade="7"
                                  bold
                                  truncate
                                >
                                  {dol.impressions === 1
                                    ? "1 impression"
                                    : `${formatNumber(
                                        dol.impressions
                                      )} impressions`}
                                </Label>
                              )}

                              {counter === "mentions" && (
                                <Label
                                  small
                                  color="gray"
                                  fade="7"
                                  bold
                                  truncate
                                >
                                  {`${formatNumber(
                                    Math.round(
                                      (dol.mentions / maxMentions) * 100
                                    )
                                  )}%`}
                                </Label>
                              )}

                              {counter === "posts" && (
                                <Label
                                  small
                                  color="gray"
                                  fade="7"
                                  bold
                                  truncate
                                >
                                  {dol.mentions === 1
                                    ? "1 post"
                                    : `${formatNumber(dol.mentions)} posts`}
                                </Label>
                              )}
                            </Row>
                          </Column>
                        ) : (
                          <Column gap="5" truncate>
                            <RowToColumn device="mobileL" gap="10" middle>
                              <H4 bold truncate>
                                {dol.name}
                              </H4>
                              <Label>@{dol.username}</Label>
                            </RowToColumn>
                            <Row truncate>
                              <Label color="gray" fade="7" truncate>
                                {dol.institutionName}
                                {dol.institutionName &&
                                  dol.country &&
                                  dol.country !== "Undetermined" &&
                                  ", "}
                                {dol.country &&
                                  dol.country !== "Undetermined" &&
                                  dol.country}
                              </Label>
                            </Row>
                          </Column>
                        )}
                      </RowToColumn>

                      {!image && (
                        <>
                          {counter === "impressions" && (
                            <Label color="gray" fade="7" bold noShrink>
                              {dol.impressions === 1
                                ? "1 impression"
                                : `${formatNumber(
                                    dol.impressions
                                  )} impressions`}
                            </Label>
                          )}

                          {counter === "mentions" && (
                            <Label color="gray" fade="7" bold noShrink>
                              {`${formatNumber(
                                Math.round((dol.mentions / maxMentions) * 100)
                              )}%`}
                            </Label>
                          )}

                          {counter === "posts" && (
                            <Label color="gray" fade="7" bold noShrink>
                              {dol.mentions === 1
                                ? "1 post"
                                : `${formatNumber(dol.mentions)} posts`}
                            </Label>
                          )}
                        </>
                      )}
                    </Row>
                  </ListItem>
                </a>
              </Column>
            );
          })}
          {maxResult === 15 && influencers?.length === 15 && (
            <Row marginTop="10">
              <Button
                secondary
                color={oncoalert ? "blue" : null}
                label="View top 25"
                onClick={() => setMaxResult(25)}
              />
            </Row>
          )}
          {maxResult === 25 && (
            <Row marginTop="10">
              <Button
                secondary
                color={oncoalert ? "blue" : null}
                label="View top 15"
                onClick={() => setMaxResult(15)}
              />
            </Row>
          )}
        </Column>
      )}
    </InfluencerListWrapper>
  );
};

const BoxWrapper = styled(Column)`
  &.chart-box {
    @media ${deviceMax.mobileL} {
      margin: 0 -20px -40px;
    }
  }
`;

export const Box = ({
  title,
  children,
  marginTop,
  bkg,
  height,
  width,
  color,
  className,
}) => {
  return (
    <BoxWrapper
      className={className ? `${className} box` : "box"}
      bkg={bkg ? "gray" : null}
      fade="1"
      paddingAll={bkg ? "20" : "0"}
      marginTop={marginTop}
      minWidth={width}
      maxWidth={width}
      minHeight={height}
    >
      <Column gap="10" marginBottom="10" fit>
        <Column fit>
          <H4 bold color={color || "green"} fade="8">
            {title}
          </H4>
        </Column>
        <HR bkg={color || "green"} fade="8" />
      </Column>
      {children}
    </BoxWrapper>
  );
};

export const HiddenComponent = ({
  conference,
  influencerStats,
  influentials,
  prolificTweeters,
  highestImpressions,
  conferenceByCountry,
  loadingConferenceByCountry,
  timeSegmentedTweets,
  loadingTimeSegmentedTweets,
  conferenceDates,
  oncoalert,
  ingestionTweetCount,
  ingestionAccountCount,
  ingestionTweetsPerHour,
  sameDate,
}) => {
  const confName = conference?.[0]?.tag?.name;
  return (
    <Column>
      <HiddenImageHeader>
        <Column paddingAll="72">
          <Row gap="40">
            <HiddenImageTitle color={oncoalert ? "blue" : null}>
              <H1 bold>
                <span>#{conference?.[0]?.tag?.name}</span>
              </H1>
              <Label large bold>
                {conferenceDates?.start &&
                  `Conference dates (${formatShortDates(
                    conferenceDates.start,
                    conferenceDates.end
                  )})`}
              </Label>
            </HiddenImageTitle>
            <Box title="Impressions">
              <H2 bold color="white">
                {formatNumber(
                  influencerStats?.postCount * influencerStats?.followers
                )}
              </H2>
            </Box>
            <Box title="Posts on X">
              <H2 bold color="white">
                {influencerStats?.postCount >= ingestionTweetCount
                  ? formatNumber(influencerStats?.postCount)
                  : formatNumber(ingestionTweetCount)}
              </H2>
            </Box>
            <Box title="Participants">
              <H2 bold color="white">
                {influencerStats?.accountCount >= ingestionAccountCount
                  ? formatNumber(influencerStats?.accountCount)
                  : formatNumber(ingestionAccountCount)}
              </H2>
            </Box>
            <Box title="Average posts per hour">
              <H2 bold color="white">
                {influencerStats?.avgPostsPerHour >= ingestionTweetsPerHour
                  ? formatNumber(influencerStats?.avgPostsPerHour)
                  : formatNumber(ingestionTweetsPerHour)}
              </H2>
            </Box>
            <Box title="Average posts per HCP">
              <H2 bold color="white">
                {formatNumber(influencerStats?.avgPostsPerAccount)}
              </H2>
            </Box>
          </Row>
          <Column>
            <Logo1>
              <img src="/images/congress/logo.png" alt="MW logo" />
            </Logo1>
            {oncoalert && (
              <Logo2>
                <img
                  src="/images/logos/oncoalert_logo.png"
                  alt="OncoAlert logo"
                />
              </Logo2>
            )}
          </Column>
        </Column>
      </HiddenImageHeader>

      <HiddenImageContent gap="20">
        <Column maxWidth="290">
          <InfluencerList
            image
            title="Top influencers"
            subtitle="Top accounts on X most mentioned by their peers"
            influencers={influentials?.data?.slice(0, 10)}
            isLoading={influentials?.isLoading}
            isSuccess={influentials?.isSuccess}
            counter="mentions"
          />
        </Column>

        <Column maxWidth="290">
          <InfluencerList
            image
            title="Most active posters"
            subtitle="Top accounts on X with the highest number of posts"
            influencers={prolificTweeters?.data?.slice(0, 10)}
            isLoading={prolificTweeters?.isLoading}
            isSuccess={prolificTweeters?.isSuccess}
            counter="posts"
          />
        </Column>

        <Column maxWidth="290">
          <InfluencerList
            image
            title="Highest impressions"
            subtitle="Top accounts on X whose posts generate the most views"
            influencers={highestImpressions?.data?.slice(0, 10)}
            isLoading={highestImpressions?.isLoading}
            isSuccess={highestImpressions?.isSuccess}
            counter="impressions"
          />
        </Column>

        <Column maxWidth="445">
          {loadingConferenceByCountry ? (
            <Row marginY="40" expand center>
              <Spinner />
            </Row>
          ) : (
            <Box
              bkg
              color={oncoalert ? "blue" : null}
              title="Posts per country"
            >
              <Row marginRight="-20">
                <FlagList data={conferenceByCountry} image />
                <DonutChart
                  color={oncoalert ? "blue" : null}
                  data={conferenceByCountry}
                  id="hiddenDonutChart"
                  size={300}
                />
              </Row>
            </Box>
          )}

          {loadingTimeSegmentedTweets ? (
            <Row marginY="40" expand center>
              <Spinner />
            </Row>
          ) : (
            <Box
              bkg
              color={oncoalert ? "blue" : null}
              title={sameDate ? "HCP posts per hour" : "HCP posts per day"}
            >
              <Column marginBottom="-20" marginX="-10">
                <SmothLineChart
                  sameDate={sameDate}
                  color={oncoalert ? "blue" : null}
                  data={timeSegmentedTweets}
                  id="hiddenLineChart"
                  size={300}
                />
              </Column>
            </Box>
          )}
        </Column>
      </HiddenImageContent>

      <HiddenImageFooter>
        <Row gap="40" middle>
          <img
            height="32px"
            src={
              oncoalert
                ? "/images/logos/medical.watch_blue.png"
                : "/medicalwatch.png"
            }
            alt="Medical.watch"
          />

          {oncoalert ? (
            <Anchor
              small
              bold
              blank
              color={oncoalert ? "blue" : null}
              to={`https://my.medical.watch/oncoalert/hashtag/${confName}`}
              label={`medical.watch/oncoalert/hashtag/${confName}`}
            />
          ) : (
            <Anchor
              small
              bold
              blank
              to={`https://my.medical.watch/influencers/hashtag/${confName}`}
              label={`medical.watch/influencers/hashtag/${confName}`}
            />
          )}
          {conference?.[0]?.url && (
            <Anchor
              small
              bold
              blank
              color={oncoalert ? "blue" : null}
              to={conference[0].url}
              label={conference[0].url
                .replace("http://", "")
                .replace("https://", "")
                .replace(/\/$/, "")}
            />
          )}
        </Row>
        <Row>
          <Label small>
            Exported at{" "}
            {new Date().toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: false,
            })}{" "}
            {new Intl.DateTimeFormat("en-US", { timeZoneName: "short" })
              .formatToParts(new Date())
              .find((part) => part.type === "timeZoneName")?.value || ""}
          </Label>
        </Row>
      </HiddenImageFooter>
    </Column>
  );
};

export const FlagList = ({ data, image }) => (
  <Column marginRight={image ? "0" : "20"}>
    {React.createElement(image ? Column : Grid, {
      ...(image
        ? { gap: "10", maxWidth: "100" }
        : { columns: 3, always: true, gap: "20" }),
      children: data?.map((item) => {
        if (item.country === "Other") {
          return null;
        }
        return (
          <Row key={item.country} middle gap="10" truncate>
            <CircleFlag
              countryCode={item.countrycode.toLowerCase()}
              height={20}
            />
            <Label truncate small={image}>
              {item.country}
            </Label>
          </Row>
        );
      }),
    })}
  </Column>
);

const HiddenImageHeader = styled.div`
  width: 1499px;
  height: 329px;
  position: relative;
  background: url("/images/congress/download-bkg.jpg");

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.2)
    );
  }

  & > div {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .box {
    max-width: 145px;

    h4 {
      height: 48px;
      color: white;
    }
    hr {
      border-color: white;
    }
  }
`;

const HiddenImageTitle = styled.div`
  color: white;
  width: 430px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  h1 {
    font-size: 60px;
    span {
      background: ${({ color }) =>
        color ? Color("blue", "6") : Color("green", "6")};
      margin-right: 5px;
    }
  }
`;

const Logo1 = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;
const Logo2 = styled.div`
  position: absolute;
  top: 110px;
  right: 0;
  img {
    height: 110px;
    width: 110px;
  }
`;

const HiddenImageContent = styled(Row)`
  position: relative;
  z-index: 2;
  padding-left: 72px;
  background: white;

  & > div {
    margin-top: -85px;
  }

  .box {
    background: white;
  }
`;

const HiddenImageFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 74px 40px 92px;
  width: 100%;
  background: white;
`;

const Wrapper = styled(Column)`
  grid-area: footer;
`;

export const OncoalertFooter = ({ grid }) => {
  return (
    <Wrapper
      center
      bkg="gray"
      fade="1"
      paddingY="100"
      paddingX="60"
      {...{ grid }}
    >
      <Grid columns={4} gap="60">
        <Column gap="20">
          <TextLogo />
          <Column gap="5">
            <Label color="gray" fade="6" small>
              Copyright {currentYear} Medical.watch
            </Label>
            <Label color="gray" fade="6" small>
              All rights reserved
            </Label>
          </Column>
          <a href="https://www.oncoalert360.com" target="_blank">
            <img
              src="/images/logos/oncoalert_dark.png"
              alt="OncoAlert logo"
              width="248px"
              height="75px"
            />
          </a>
        </Column>
        <Column gap="20">
          <Label bold>Company</Label>
          <Anchor label="Privacy Policy" color="black" to="/privacy" />
          <Anchor label="Terms of Service" color="black" to="/terms" />
        </Column>
        <Column gap="20">
          <Label bold>Follow us</Label>
          <Anchor
            label="Medical.watch on X"
            color="black"
            blank
            to="https://x.com/MedicalwatchFTW"
          />
          <Anchor
            label="OncoAlert on X"
            color="black"
            blank
            to="https://x.com/OncoAlert"
          />
        </Column>
      </Grid>
    </Wrapper>
  );
};
